


















import moment from "moment";
import { DateUtils } from "../../utils/DateUtils";
import Months = DateUtils.Months;

export default {
    name: "MonthSelector",
    props: {
        value: DateUtils.Month,
        startDay: Number,
    },
    data() {
        return {
            month: moment().month() + 1,
            year: moment().year(),
            Months: DateUtils.Months,
            monthsList: [],
        };
    },
    created() {
        let self = this;

        self.monthsList = _.map(self.Months, function (month) {
            let name = month.name;
            if (self.startDay) {
                let previousMonth = Months[((month.id + 10) % 12) + 1];
                name =
                    self.startDay +
                    " " +
                    previousMonth.name +
                    " - " +
                    (self.startDay - 1) +
                    " " +
                    month.name;
            }
            return {
                id: month.id,
                month: month,
                name: name,
            };
        });
    },
    computed: {
        monthYear: function () {
            return this.year + "-" + this.month;
        },
    },
    watch: {
        monthYear: {
            immediate: true,
            handler: function () {
                this.$emit("input", { year: this.year, month: this.month });
            },
        },
    },
};
